import { Container } from '@mui/material';
import { PermissionBoundary } from '../../../core/permissions/permission-boundary.component';
import { WindowTitle } from '../../../core/window-title/window-title.component';
import { ErrorFullPage } from '../../../ui/components/pure/errors/error-full-page/error-full-page.component';
import { ListPageHeader } from '../../../ui/components/pure/page-headers/list/list-page-header.component';
import { CourierLoginForm } from './components/courier-login-form.component';
import { useCourierLoginTesting } from './courier-login-testing.hook';
import { CourierLoginTestingTable } from './courier-login-testing.table';

export function CourierLoginTestingPage() {
  const { state, couriersList, isLoading, isError, onSubmit } = useCourierLoginTesting();

  let isErrorOverride = isError;
  let errorMessage = state.errorMessage;

  if (!isError) {
    if (state.whoAmI?.alerts?.isOccupant === true) {
      isErrorOverride = true;
      errorMessage = 'This mobile number belongs to an Occupant.';
    } else if (state.whoAmI?.couriers.length === 0) {
      isErrorOverride = true;
      errorMessage = 'No Couriers or Team Members found with this mobile number.';
    }
  }

  return (
    <Container>
      <PermissionBoundary
        availableUiFeatures={['internal-groundfloor']}
        notify={{
          render() {
            return <ErrorFullPage preset="ACCESS_DENIED" />;
          }
        }}
      >
        <WindowTitle pageTitle="Reports" detail="Courier App Login Testing" />
        <ListPageHeader
          title="Courier App Login Testing"
          subtitle="Troubleshoot logging in to the Courier Mobile App as a Courier or Team Member"
        />
        <CourierLoginForm onSubmit={onSubmit} />
        <CourierLoginTestingTable
          couriers={couriersList}
          isLoading={isLoading}
          isError={isErrorOverride}
          errorMessage={errorMessage || undefined}
        />
      </PermissionBoundary>
    </Container>
  );
}
